@if (product()) {
  @if ((product()?.OfferId)) {<!--More complex logic with an offer-->
  @if (isBundleProduct(product())) {<!--Bundle product-->
  @if ((product()?.OfferDiscountAmount?.Amount > 0)) {<!--Discount-->
<span class="nowrap">
  <span class="strikethrough">{{product()?.PriceStandard?.AmountFormatted}}</span>
</span>&ngsp;
<span class="nowrap">
  <span class="offer_price"> {{product()?.Price?.AmountFormatted}}</span>
  <span> for {{product()?.Minutes}} minutes</span>
</span>&ngsp;
<span class="nowrap">
  <span> You save </span>
  <span class="offer_price">{{product()?.OfferDiscountAmount?.AmountFormatted}} ({{product()?.OfferDiscountPercent}}%)</span>
</span>
  } @else {<!--Non discount-->
<span class="nowrap">
  <span class="nowrap">{{product()?.Price?.AmountFormatted}} for {{product()?.Minutes}} minutes</span>
</span>
  @if ((product()?.OfferBonusAmount?.Amount > 0 )) {
<div>
  <span>
    <span>Bonus of </span>
    <span class="offer_price">{{product()?.OfferBonusAmount?.AmountFormatted}} </span>
  </span>&ngsp;
  <span class="nowrap">
    <span>will be added</span>
  </span>
</div>
  }
  }

  } @else if (isPaygProduct(product())) {<!--PAYG product-->
    @if ((product()?.OfferDiscountAmount?.Amount > 0 )) {
      <span class="nowrap">
          <span class="strikethrough">{{product()?.PriceStandard?.AmountFormatted}}</span>
      </span>
      <span class="nowrap">
          <span class="offer_price"> {{product()?.Price?.AmountFormatted}}</span>
          <span> for {{product()?.PriceStandard?.AmountFormatted}} PAYG credit</span>
      </span>  
    } @else if ((product()?.OfferBonusAmount?.Amount > 0 )) {
      <span class="nowrap">
          <span class="offer_price">{{product()?.OfferBonusAmount?.AmountFormatted}}</span>
          <span> off</span>
      </span>
      <span class="nowrap">
        <span class="offer_price"> {{product()?.Price?.AmountFormatted}}</span>
        <span> for {{product()?.OfferAmountCredited?.AmountFormatted}} PAYG credit</span>
      </span>
    }
  } @else if (isMinutesProduct(product())) {<!--Minutes product-->
  @if ((product()?.OfferBonusAmount?.Amount > 0 )) {
<span class="nowrap">
  <span class="nowrap">{{product()?.Price?.AmountFormatted}} for&ngsp;<span class="strikethrough">{{product()?.MinutesStandard}}</span>&ngsp;<span class="offer_price">{{product()?.Minutes}}</span>&ngsp;minutes</span>
</span>
  }@else {
<span class="nowrap">
  <span class="nowrap">{{product()?.Price?.AmountFormatted}} for {{product()?.Minutes}} minutes</span>
</span>
  }

  } @else {<!--Topup product-->

<span class="nowrap">
  <span class="nowrap">{{product()?.Price?.AmountFormatted}} topup</span>
</span>
  @if ((product()?.OfferBonusAmount?.Amount > 0 )) {
<div>
  <span>
    <span>Bonus of </span>
    <span class="offer_price">{{product()?.OfferBonusAmount?.AmountFormatted}} </span>
  </span>&ngsp;
  <span class="nowrap">
    <span>will be added</span>
  </span>
</div>
  }

  }
  @if(isLoyaltyOffer(product())){
<div class="offer_price">
  Loyalty Bonus
  <span class="help-tooltip-container">
    <div class="help-tooltip-icon">
      <span>
        <span>?</span>
      </span>
      <div class="help-tooltip-tooltip tooltip-below">
        <div>
          Loyalty Bonus applied every 200 {{resources?.reading}} minutes.
        </div>
      </div>
    </div>
  </span>
</div>
  }
  } @else {<!--No offer, simpler logic-->
  @if (isBundleProduct(product()) || isMinutesProduct(product())) {
<span class="nowrap">
  <span class="nowrap">{{product()?.Price?.AmountFormatted}} for {{product()?.Minutes}} minutes</span>
</span>
  } @else if (isPaygProduct(product())) {<!--PAYG product-->
  <span class="nowrap">
      <span>{{product()?.Price?.AmountFormatted}} PAYG credit</span>
  </span>
  } @else {
<span class="nowrap">
  <span class="nowrap">{{product()?.Price?.AmountFormatted}} topup</span>
</span>
  }
  }
}
